module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "imagef"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f001-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h2n"
  }, [_vm._v("INTRODUCTION")]), _vm._v(" "), _c('p', {
    staticClass: "h2c"
  }, [_vm._v("this book is required reading")]), _vm._v(" "), _c('p', {
    staticClass: "imagef1"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ccenter"
  }, [_c('em', [_vm._v("Only connect.")])]), _vm._v(" "), _c('p', {
    staticClass: "ccenter1"
  }, [_vm._v("—E. M. Forster, "), _c('em', [_vm._v("Howards End")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "underlev"
  }, [_vm._v("Learning Latin in Greek")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("On my first day of grad school at Cornell University, I attended microeconomics. The professor, in an attempt to calm our first-year jitters, explained in soothing tones that he would be showing a lot of graphs, yet there was no need to panic. He said, “Think of graphs as flowcharts, and you’ll be fine.” As an arts professional with no background whatsoever in economics, I suddenly felt dizzy as my vision blurred. I had never heard of a flowchart. I was doomed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v("I now describe the experience of those first few weeks in business school as like trying to learn Latin in Greek … except I didn’t know Greek either. No matter how earnestly I took notes, a few hours later I had no idea what they meant.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A comparable pitfall exists when a self-declared "), _c('em', [_vm._v("non-networker")]), _vm._v(" tries hard to follow networking rules written for a different species altogether. There is no point of reference. No mental bucket exists in which to dump the data. The data is fine. It is just in a foreign language. "), _c('em', [_vm._v("This")]), _vm._v(" networking book, on the other hand, is written in language spoken and understood by introverts, the overwhelmed, and the underconnected. What luck! You finally have a chance at a passing grade.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By the way, for many years now I have been invited back to teach networking at Cornell. I have not yet been asked to lecture on economics, however.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "underlev"
  }, [_vm._v("Networking for People Who Hate Networking")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Why would such a book exist? Isn’t it a bit like giving quiche recipes to people allergic to eggs and cheese? Or surrounding oneself with fragrant flowers despite suffering from severe hay fever? If you have an aversion to something not "), _c('em', [_vm._v("absolutely")]), _vm._v(" necessary, why not occupy your life with alternative endeavors? Why torture yourself?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("These are solid questions. Thanks for asking.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Allow me to begin by saying I agree 100 percent. Do not waste a single precious hour on an activity you hate! Still, you don’t get off the hook that easily. You don’t get to place this book back on the shelf (or e-shelf, as the case may be), proclaiming yourself oil to networking’s vinegar.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Instead, I am going to perform the astounding trick of making networking enjoyable and rewarding. All without mind-altering substances! So find a comfy chair or patch of grass, crease this spine, and commit. You won’t regret it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _vm._v("Our field guide begins by politely examining—and then shatt ering to pieces—traditional networking truisms. Commandments along the lines of:")]), _vm._v(" "), _c('p', {
    staticClass: "bulltz"
  }, [_c('span', {
    staticClass: "col"
  }, [_vm._v("∎")]), _vm._v("   Promote yourself constantly.")]), _vm._v(" "), _c('p', {
    staticClass: "bullz"
  }, [_c('span', {
    staticClass: "col"
  }, [_vm._v("∎")]), _vm._v("   More contacts = higher probability of success.")]), _vm._v(" "), _c('p', {
    staticClass: "bullz"
  }, [_c('span', {
    staticClass: "col"
  }, [_vm._v("∎")]), _vm._v("   Never eat alone.")]), _vm._v(" "), _c('p', {
    staticClass: "bullz"
  }, [_c('span', {
    staticClass: "col"
  }, [_vm._v("∎")]), _vm._v("   Create nonstop touchpoints.")]), _vm._v(" "), _c('p', {
    staticClass: "bullz"
  }, [_c('span', {
    staticClass: "col"
  }, [_vm._v("∎")]), _vm._v("   Get "), _c('em', [_vm._v("out there")]), _vm._v(" as much as possible.")]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f003-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Until my first edition hit the presses, networking books were all writt en for people of a particular temperament—the very personality style already predisposed to relish the prospect of spearing cheese in a room full of bustling strangers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Turns out this personality type comprises a paltry 15 percent of the general population."), _c('a', {
    attrs: {
      "href": "#/xhtml/#star",
      "id": "star1"
    }
  }, [_vm._v("*")]), _vm._v(" I am certain this is an unintended oversight on the part of other, well-meaning authors. Nevertheless, smoke comes out of my ears just thinking about it. The other 85 percent of humankind is dismissed. Misled. Bamboozled. It is time to take back our rightful share of the networking world.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Along the way we will discover the enormous value of leveraging our natural style when networking. No more stamping out our instincts.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "underlev"
  }, [_vm._v("Why Bother?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("What’s that you’re mumbling? You don’t like networking and have no interest, anyway? It drains you? It never works? You don’t have time? You don’t need to? It’s phony, self-serving, fake, inauthentic, superficial, conniving, manipulative, and useless?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("Hold it right there. Take a sip of water. Pull yourself together.")]), _vm._v(" "), _c('p', {
    staticClass: "centertb"
  }, [_c('strong', [_vm._v("Introverts, the overwhelmed, and the underconnected fail at traditional networking by following advice never intended for us in the first place.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In my experience, people who proclaim that they hate networking also believe they are not good at it. In fact, the reverse is true. You have the raw materials to be a stellar networker. You are simply following the wrong rules. Standard networking advice fails you, so you assume you fail at networking. Plus, you "), _c('em', [_vm._v("hate")]), _vm._v(" it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Finally, you can learn a method of networking in keeping with the real you. Not a moment too soon!")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "underlev"
  }, [_vm._v("What’s at Stake?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Only whatever you most want to accomplish in your life. No biggie.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Networking allows you to achieve your potential. Think of a Big Goal. Do you want to find a job, score a promotion, make a new contact, improve the world, expand your influence, sell a product, provide a service, write a book, seal a deal, improve collaboration, build a reputation, achieve your dream, widen your circles, or grow a business?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Networking will further your aim. In over twenty years as an executive coach, I have never met a person who did not benefit substantially from learning how to network—on his or her own terms.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What is networking, really? Networking is the art of building and maintaining mutually beneficial connections for shared positive outcomes.")]), _vm._v(" "), _c('p', {
    staticClass: "centertb"
  }, [_c('strong', [_vm._v("Real networking is connecting.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Authenticity yields valuable, resilient networks. Ready for a networking system reliant on being true to yourself, mobilizing qualities you already have? Learn to work with, rather than fight against, "), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("your lovable introverted, overwhelmed, and/or underconnected self. Honoring your temperament is the secret to achieving your highest potential. Previously labeled liabilities are now your finest strengths.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Enticed?")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "underlev"
  }, [_vm._v("Return on Investment (ROI)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Time is your most valuable asset (unless, perhaps, you are spectacularly wealthy). What about this field guide merits devoting a couple hours of your precious time to it rather than "), _c('em', [_vm._v("all")]), _vm._v(" the other competing options out there?")]), _vm._v(" "), _c('p', {
    staticClass: "nlisttz"
  }, [_vm._v("a.  You will discover a super-effective, groundbreaking method of networking described in accessible, easy-to-understand language.")]), _vm._v(" "), _c('p', {
    staticClass: "nlistz"
  }, [_vm._v("b.  You will gain dozens of practical tips while learning clear, relevant action steps with "), _c('em', [_vm._v("direct")]), _vm._v(" application to your own networking goals.")]), _vm._v(" "), _c('p', {
    staticClass: "nlistz"
  }, [_vm._v("c.  You will benefit from myriad real-life examples spanning many fields.")]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_vm._v("Grab a pen; you’ll need it. There is no such thing as a free ride. Glad to have you along."), _c('a', {
    attrs: {
      "id": "page_6"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "foot1"
  }), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#star1",
      "id": "star"
    }
  }, [_vm._v("*")]), _vm._v("Myers, McCaulley, Quenk, and Hammer, "), _c('em', [_vm._v("Myers-Briggs Type Indicator Manual")]), _vm._v(" (Saint Paul, MN: Consulting Psychologist Press, 1998).")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-257f09c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/introduction.vue
// module id = 81
// module chunks = 0